import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { FactureService } from 'src/app/service/facture.service';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Facture } from 'src/app/entity/Facture';
import { Pjoint } from 'src/app/entity/Pjoint';
import { AppSettings } from 'src/app/service/app.setting';
import { Client } from 'src/app/entity/exhibitor';

@Component({
  selector: 'app-facturation-client',
  templateUrl: './facturation-client.component.html',
  styleUrls: ['./facturation-client.component.css']
})
export class FacturationClientComponent implements OnInit ,OnChanges{


  ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
 
    this.financeReporting(this.selectedClient.idClient);

  }

  nContrat: string;
  nFactures:string;
  totalFactures: number;
  totalPaiement: number;
  solde: number;
  devise:string;
  multiFact:boolean;
 @Input() selectedClient:Client
  financeReporting(idClient: number) {
    this.factureService.findByParticipant(idClient).subscribe(result => {
      this.totalFactures = 0;
      this.totalPaiement = 0;
      this.solde = 0;
      let nbrFact=0;
      result.forEach(facture => {
        if (!facture.annuler) {
          nbrFact++;
          if (facture.type === 'Principal') {
            this.nContrat = facture.numeroFicheContrat;
          }

if(nbrFact>1)
this.multiFact=true;
//console.log(this.multiFact+''+nbrFact);

let nFacture=facture.numeroFiche;

if(!nFacture)
nFacture=facture.idfacture+"";
if(nbrFact>1)
this.nFactures=(nFacture+", "+this.nFactures) ;
else
this.nFactures= nFacture  ;

          this.totalFactures += facture.montantttc;
          this.totalPaiement += facture.encaisser;
          this.solde += facture.reste;


        }
      });
    })
  }
 
  factures: Facture[];

  constructor(private clientService: ExhibitorService, private activatedRoute: ActivatedRoute,private router:Router,
     private factureService: FactureService) {
    
  }
  ngOnInit() {
    this.devise=this.selectedClient.prospectId.devise;

  }
   // window.open('http://192.168.92.200:5001/participants/invoices/'+this.selectedClient.idClient,'_blank');

  clickedMe(){
 
 
   // this.router.navigateByUrl(`/add-exhibitor/${this.selectedClient.idClient}/3`  )  
    
  }


  fileURL: string;
  openFile(pjoint: Pjoint, download: boolean, folder: string) {
    this.factureService.pjointFile(pjoint, folder).subscribe(res => {
    //  res.name = pjoint.fileName;
      //    saveAs(res, res.name);
      let fileURL = URL.createObjectURL(res);
      this.fileURL = fileURL;
      if (download)
        window.open(fileURL);
    }, (err) => { //console.log('aeeeerrrree' + err);
     });
  }
  openContract(pjoint: Pjoint, download: boolean) {
    this.openFile(pjoint, download, AppSettings.CONTRACT_FOLDER);
  }
  getClientContract(download: boolean) {
    this.clientService.getExhibitor(this.selectedClient.idClient).subscribe(result => {


      this.selectedClient = result;
      if (this.selectedClient.pjointContrat)
        this.openContract(this.selectedClient.pjointContrat, download)

    });

  }

 


}
